export enum ESwitchSize {
  L = 'L',
  M = 'M',
  S = 'S',
}

export type TSwitchSize = keyof typeof ESwitchSize;
